/* eslint-disable perfectionist/sort-objects */

const colorScale = 12;
const radixColors = [
  "tomato",
  "red",
  "ruby",
  "crimson",
  "pink",
  "plum",
  "purple",
  "violet",
  "iris",
  "indigo",
  "blue",
  "cyan",
  "teal",
  "jade",
  "green",
  "grass",
  "bronze",
  "gold",
  "brown",
  "orange",
  "amber",
  "yellow",
  "lime",
  "mint",
  "sky",
];
const radixGrayColors = ["mauve", "slate", "sage", "olive", "sand"];

const getAlphaColor = (color: string, scale: number) => {
  const colors = Array.from(Array(scale).keys()).reduce((acc, _, i) => {
    acc[`a${i + 1}`] = `var(--${color}-a${i + 1})`;
    return acc;
  }, {} as Record<number | string, string>) as Record<number | string, string>;

  return colors;
};

const getColor = (color: string, s?: number) => {
  const scale = s || colorScale;
  let colors = Array.from(Array(scale).keys()).reduce((acc, _, i) => {
    acc[i + 1] = `var(--${color}-${i + 1})`;
    acc[`a${i + 1}`] = `var(--${color}-a${i + 1})`;
    return acc;
  }, {} as Record<number | string, string>) as Record<number | string, string>;

  colors = {
    ...colors,
    ...{
      contrast: `var(--${color}-contrast)`,
      indicator: `var(--${color}-indicator)`,
      surface: `var(--${color}-surface)`,
      track: `var(--${color}-track)`,
    },
  };

  return colors;
};

const getColors = (arr: string[]) => {
  const colors = arr.reduce((acc, color) => {
    acc[color] = getColor(color, colorScale);
    return acc;
  }, {} as Record<string, Record<number | string, string>>);
  return { ...colors };
};

const getThemeColors = () => {
  return {
    // https://github.com/radix-ui/themes/blob/50b29e5baf98fc2ce9738498d260a853d6d28891/packages/radix-ui-themes/src/styles/tokens/color.css#L143-L174
    "accent": getColor("accent", colorScale),
    // https://github.com/radix-ui/themes/blob/50b29e5baf98fc2ce9738498d260a853d6d28891/packages/radix-ui-themes/src/styles/tokens/color.css#L1008-L1039
    "gray": getColor("gray", colorScale),
    // https://github.com/radix-ui/colors/blob/main/src/whiteA.ts
    "white": getAlphaColor("white", colorScale),
    // https://github.com/radix-ui/colors/blob/main/src/blackA.ts
    "black": getAlphaColor("black", colorScale),

    // semantic color
    "info": getColor("blue", colorScale),
    "success": getColor("grass", colorScale),
    "warning": getColor("amber", colorScale),
    "danger": getColor("tomato", colorScale),

    // semantic radix colors
    // https://github.com/radix-ui/themes/blob/50b29e5baf98fc2ce9738498d260a853d6d28891/packages/radix-ui-themes/src/styles/tokens/color.css#L10-L24
    "background": "var(--color-background)",
    "overlay": "var(--color-overlay)",
    "panel": "var(--color-panel)",
    "panel-solid": "var(--color-panel-solid)",
    "panel-translucent": "var(--color-panel-translucent)",
    "surface": "var(--color-surface)",

    // tailwind default
    "current": "currentColor",
    "transparent": "transparent",
    "inherit": "inherit",

    // other radix colors
    ...getColors(radixGrayColors),
    ...getColors(radixColors),
  };
};

export { getColor, getThemeColors };
